export default class ProgressBarService {

  constructor($q, ngProgressFactory) {
    'ngInject';
    this.$q = $q;
    this.ngProgressFactory = ngProgressFactory
    this.progressBar = this.ngProgressFactory.createInstance();
  }

  start() {
    this.progressBar.setColor('#00FCFF');
    this.progressBar.setHeight('4px');
    return this.progressBar.start();
  }

  complete() {
    return this.progressBar.complete();
  }

  wrap(data) {
    data = this.$q.resolve(data); // make sure it's a promise

    this.start();
    return data.finally(() => {
      this.complete();
    });
  }
}
